import { Button, Checkbox, CircularProgress, Dialog, DialogContent, Grid, ThemeProvider, useTheme } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import { GetFormsData, GetTemplateAndCategory, UpdateFormsData } from "../../../../api";
import useStyles from "../../../../css/styles_PE";
import { EMRConfig } from "../../../../store";

// FB  8276   09/02/2024  SK   Feature to allow patients to complete certain forms using Portal

export default function Forms() {
  const [showSpinner, setShowSpinner] = useState(false);
  const [patient_n, setPatientn] = useState(0);
  const theme = useTheme();
  const [FormsDetails, setFormsDetails] = useState<
    Array<FormsProps>
  >([]);
  type FormsProps = {
    Patient_n: any;
    Template_Name: any;
    DataTimeOfRequest: any;
    DateTimeLastUpdated: any;
    Status: any;
    Form_Name: any;
  };
  async function getFormsDetails() {
    var dataEMR = sessionStorage.getItem("user");
    if (dataEMR != null) {
      const user = JSON.parse(dataEMR);
      if (user.Patient_n != null) {
        setPatientn(user.EMRID)
        var data = await GetFormsData(user.EMRID);
        setShowSpinner(false);
        setFormsDetails(data);
      }
    }
  }


  
  const handleClick = async (templateName: any, formName: any) => {
    let obj = sessionStorage.getItem("EMRConfig");
    var EMRbaseURL;
    if (obj != null) {
      let config = JSON.parse(obj) as EMRConfig;
      EMRbaseURL = config.EMRURL + "/";
    }
    await UpdateFormsData(patient_n, formName, templateName);
    let data = await GetTemplateAndCategory(templateName);
    const url = EMRbaseURL + "patient_intake/note_add_edit.asp?CATEGORY_N=" + data[0].Category_n + "&TEMPLATE_N=" + data[0].Template_n + "&patient_n=" + patient_n+ "&portal=1&TEMPLATE_LABEL="+templateName;
    window.open(url, '_blank');
  };


  const styles = useStyles();
  useEffect(() => {
    setShowSpinner(true);
    getFormsDetails();
  }, []);
  return (

    <div
      style={{
        paddingLeft: "35px",
        paddingTop: "16px",
        backgroundColor: "#F5F5F5",
        height: "100%",
      }}
    >
      <div
        style={{
          paddingTop: "16px",
          fontWeight: "bold",
        }}
      >
        Forms{" "}
        <hr
          style={{ height: "2px", border: "none", backgroundColor: "black" }}
        ></hr>
      </div>
      <div>
        <div style={{ paddingTop: "20px", paddingRight: "35px" }}>
          <TableContainer component={Paper} style={{ marginTop: "20px" }}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">
                    <strong>Form Name</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>Form Created Date</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>Form Modified Date</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>Status</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {FormsDetails
                  .filter(x => x.Status === "AssignToPatient" || x.Status === "Started")
                  .map((x) => (
                    <TableRow
                      key={x.Patient_n}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell align="center" style={{
                        color: "#13607C",
                        textDecoration: "underline",
                        cursor: "pointer"
                      }}
                        onClick={() => handleClick(x.Template_Name , x.Form_Name)}>
                        {x.Form_Name}
                      </TableCell>
                      <TableCell align="center">
                        {new Date(x.DataTimeOfRequest)
                          .toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                          })
                          .replace(",", "")}{" "}
                      </TableCell>
                      <TableCell align="center">
                        {new Date(x.DateTimeLastUpdated)
                          .toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                          })
                          .replace(",", "") === "01/01/1" ? "" :
                          new Date(x.DateTimeLastUpdated)
                            .toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                            })
                            .replace(",", "")}{" "}
                      </TableCell>

                      <TableCell align="center">
                        {x.Status === "assigntopatient" ? "For not started" : x.Status}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <br />
        <ThemeProvider theme={theme}>
          <Dialog open={showSpinner} fullWidth maxWidth={"xs"}>
            <DialogContent
              style={{
                display: "flex",
                alignContent: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress style={{ color: "#083A4D" }} />
            </DialogContent>
          </Dialog>
        </ThemeProvider>
      </div>
    </div>

  )
}